import React, { useState } from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './GamePage.css';

const GamePage = (props) => {
    const [classBtn1, setClassBtn1] = useState('Place1 ');
    const [classBtn2, setClassBtn2] = useState('Place2 ');
    const [buttonHidden, setButtonHidden] = useState(false);
    const handleClick = ((pri, butNumb) => {
        if (pri === 'answer') {
            if (butNumb === 'Btn1') setClassBtn1('Place1 Answer');
            else setClassBtn2('Place2 Answer');
            setButtonHidden(true);
            props.onClick('answer');

        }
        if (pri === 'wrong') {
            if (butNumb === 'Btn1') setClassBtn1('Place1 Wrong');
            else setClassBtn2('Place2 Wrong');

        }

    });


    let answer = ((props.rightButton === 0) ? (<div>
        <Button className={classBtn1} hidden={buttonHidden} onClick={(pri, butNumb) => handleClick('answer', 'Btn1')} value={props.answer} />
        <Button className={classBtn2} hidden={buttonHidden} onClick={(pri, butNumb) => handleClick('wrong', 'Btn2')} value={props.wrong} />
    </div>) : (<div>
            <Button className={classBtn2} hidden={buttonHidden} onClick={(pri, butNumb) => handleClick('answer', 'Btn2')} value={props.answer} />
            <Button className={classBtn1} hidden={buttonHidden} onClick={(pri, butNumb) => handleClick('wrong', 'Btn1')} value={props.wrong} />
    </div>));

    return (
        <div>
            <img src={props.bgSrc} className='smallBg' alt=' ' />
            <Text className='Task' value={props.task} />
            <div className='Place0' hidden={!buttonHidden}  > {props.answer} </div>
            <img className='Gerb' src={props.src} alt='' />
            <img className='Gorod' src={props.srcImg} alt='' />
            {answer}
            <Button className='GamePrev' onClick={() => props.onClick('prev')} hidden={(props.step === 0) ? true : false} />
            <Text className='Link' value={(props.lang === 'rus') ? ('Фото: ' + props.link + '. Свободный доступ') : ('Kuva: ' + props.link + '. Yleinen käyttö')} />
        </div>
    );
};

export default GamePage;